var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificate-card-nothing"},[_c('icon',{staticClass:"icon-question",attrs:{"name":"question"}}),_c('p',{staticClass:"text"},[_vm._v("暂无健康证明信息")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }